import langTitle from './lang.json';

const all = {
  title: { ...langTitle },
};
export default all;
